<nav class="menu">
  <ul>
    <li *ngFor="let item of items" [routerLink]="['/', item.path]" routerLinkActive="active">
      <span class="material-symbols-outlined icon">{{ item.icon }}</span>
      <span class="label" [class.hidden]="collapsed">{{ item.label | translate }}</span>
    </li>
  </ul>
</nav>
